import React, { ReactNode } from 'react';
import { CheckCircleIcon, ShieldCheckIcon, SparklesIcon } from '@heroicons/react/24/outline';
import euformsLogo from '../../images/euforms.png';

type AuthShellProps = {
  eyebrow?: string;
  title: string;
  description: string;
  children: ReactNode;
};

export default function AuthShell({ eyebrow = 'Formulários', title, description, children }: AuthShellProps) {
  return (
    <main className="auth-shell">
      <section className="auth-brand-panel" aria-label="Formulários by Eupago">
        <div className="auth-brand-glow auth-brand-glow-one" />
        <div className="auth-brand-glow auth-brand-glow-two" />
        <div className="auth-brand-content">
          <a href="/" className="auth-logo" aria-label="Voltar à página inicial">
            <img src={euformsLogo} alt="Formulários" />
          </a>

          <div className="auth-brand-copy">
            <span className="auth-kicker"><SparklesIcon /> Formulários que trabalham por si</span>
            <h2>Crie, publique e receba pagamentos num só lugar.</h2>
            <p>Uma experiência simples e segura para gerir inscrições, pedidos e pagamentos com a confiança Eupago.</p>
            <div className="auth-features">
              <div className="auth-feature"><ShieldCheckIcon /><span>Dados protegidos</span></div>
              <div className="auth-feature"><CheckCircleIcon /><span>Gestão centralizada</span></div>
            </div>
          </div>

          <p className="auth-copyright">© 2014–2026 Eupago · Formulários</p>
        </div>
      </section>

      <section className="auth-form-panel">
        <div className="auth-card">
          <img src={euformsLogo} alt="Formulários" className="auth-mobile-logo" />
          <p className="auth-form-eyebrow">{eyebrow}</p>
          <h1 className="auth-title">{title}</h1>
          <p className="auth-description">{description}</p>
          <div className="auth-form-content">{children}</div>
        </div>
      </section>
    </main>
  );
}
